import { PointerSensor } from '@dnd-kit/core';
import { type PointerEvent } from 'react';

/**
 * An extended "PointerSensor" that prevent some
 * interactive html element(button, input, textarea, select, option...)
 * from dragging
 *
 * @see https://github.com/clauderic/dnd-kit/issues/477
 */
export class SmartPointerSensor extends PointerSensor {
  static activators = [
    {
      eventName: 'onPointerDown' as const,
      handler: ({ nativeEvent: event }: PointerEvent) => {
        if (
          !event.isPrimary ||
          event.button !== 0 ||
          isInteractiveElement(event.target as Element)
        ) {
          return false;
        }

        return true;
      },
    },
  ];
}

function isInteractiveElement(element: Element | null) {
  const interactiveElements = [
    'button',
    'input',
    'textarea',
    'select',
    'option',
  ];
  if (
    element?.tagName &&
    interactiveElements.includes(element.tagName.toLowerCase())
  ) {
    return true;
  }

  return false;
}
